export default {
  ActivityLogImportJob: 'アクティビティログのインポート',
  AllSurveysDataMigrationJob: '全調査のデータ移行',
  ArenaMobileDataImportJob: 'Arenaデータのインポート',
  ArenaMobileDataImportSummaryJob: 'Arenaデータインポートの概要',
  CategoriesImportJob: 'カテゴリのインポート',
  CategoriesValidationJob: 'カテゴリの検証',
  CategoriesBatchImportJob: 'カテゴリのインポート',
  CategoryImportJob: 'カテゴリのインポート',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'カテゴリの検証',
  ChainsSamplingNodeDefsCheckJob: '処理チェーンのサンプリングノード定義作成',
  ChainsValidationJob: '処理チェーンの検証',
  ChainsImportJob: '処理チェーンのインポート',
  CollectDataImportJob: 'Collectデータのインポート',
  CollectImportJob: 'Collectのインポート',
  CollectSurveyReaderJob: 'Collect調査の読み込み',
  CyclesDeletedCheckJob: '削除済みサイクルの確認',
  DataDeleteJob: 'データの削除',
  DataImportJob: 'データのインポート',
  DataImportValidationJob: 'インポートファイルの検証',
  EntitiesDeleteJob: '既存項目の削除',
  FilesImportJob: 'ファイルのインポート',
  MessageSendJob: 'メッセージの送信',
  NodeDefsTranslationJob: 'ノード定義ラベルの翻訳',
  NodeDefsImportJob: 'ノード定義のインポート',
  NodeDefsValidationJob: 'ノード定義の検証',
  OdkImportJob: 'ODKのインポート',
  OdkDataImportJob: 'ODKデータのインポート',
  OdkFormReaderJob: 'ODKフォームの読み込み',
  OdkSubmissionReaderJob: 'ODK提出データの読み込み',
  ChainsCyclesCheckJob: `処理チェーンのサイクル確認`,
  RecordCheckJob: '記録の確認',
  RecordsCloneJob: '記録の複製',
  RecordsImportJob: '記録のインポート',
  RecordsImportSummaryJob: '記録インポートの概要',
  RecordsUniquenessValidationJob: '記録の一意性検証',
  SamplingPointDataImportJob: '抽出地点データのインポート',
  SamplingPointDataImportInternalJob: '抽出地点データのインポート',
  SchemaSummaryExportJob: 'スキーマ概要のエクスポート',
  SelectedRecordsExportJob: '選択した記録のエクスポート',
  SurveyActivityLogClearJob: '調査アクティビティログの消去',
  SurveyCreatorJob: '調査の作成',
  SurveyDataMigrationJob: '調査データの移行',
  SurveyDependencyGraphsGenerationJob: '調査の依存関係グラフ生成',
  SurveyExportJob: '調査のエクスポート',
  SurveyCompareJob: '調査の比較',
  SurveyCompareDiffJob: '差分の計算',
  SurveyCompareApplyJob: '調査の変更の適用',
  SurveyFilesImportJob: '調査ファイルのインポート',
  SurveyIndexGeneratorJob: '調査インデックスの生成',
  SurveyInfoValidationJob: '調査情報の検証',
  SurveyLabelsImportJob: '調査ラベルのインポート',
  SurveyPropsPublishJob: '調査プロパティの公開',
  SurveyPublishJob: '調査の公開',
  SurveyPublishPerformJob: '調査の公開処理',
  SurveyRdbCreationJob: '調査RDBの作成',
  SurveyRdbSchemaCreationJob: '調査RDBスキーマの作成',
  SurveyRdbDataTablesAndViewsCreationJob: '調査RDBデータテーブルとビューの作成',
  SurveyRdbOlapDataTablesCreationJob: '調査RDB OLAPデータテーブルの作成',
  SurveyUnpublishJob: '調査の公開取り消し',
  SurveyPropsUnpublishJob: '調査プロパティの公開取り消し',
  SurveysListExportJob: '調査一覧のエクスポート',
  SurveysRdbRefreshJob: '調査RDBの更新',
  TaxonomiesImportJob: '分類体系のインポート',
  TaxonomiesValidationJob: '分類体系の検証',
  TaxonomyImportJob: '分類体系のインポート',
  UsersBackupExportJob: 'ユーザーのバックアップ',
  UsersBackupImportJob: 'ユーザーの復元',
  // data export
  ArenaFileReadJob: 'Arenaファイルの読み込み',
  DataExportJob: 'データのエクスポート',
  DataMatrixExportJob: 'データマトリクスのエクスポート',
  DataSummaryExportJob: 'データ概要のエクスポート',
  ZipCreationJob: 'ZIPファイルの作成',
  CSVDataExtraction: 'データの抽出',
  FilesExportJob: 'ファイルのエクスポート',
  PrepareImportFileJob: 'インポートファイルの準備',
  // geo
  GeoJsonDataExportJob: 'GeoJsonデータのエクスポート',
  // import arena survey
  ArenaImportJob: 'Arenaのインポート',
  ArenaSurveyReaderJob: 'Arena調査の読み込み',
  CreateRdbJob: '調査RDBの作成',
  UsersImportJob: 'ユーザーのインポート',
  // clone survey
  SurveyCloneJob: '調査の複製',
  CloneSurveyJob: '調査の複製',
  // survey backup
  SurveyInfoExportJob: '調査情報のエクスポート',
  CategoriesExportJob: 'カテゴリのエクスポート',
  CategoryGeoPackageExportJob: 'カテゴリGeoPackageのエクスポート',
  SamplingPointDataWhispJob: 'サンプリングポイントデータのWhisp分析',
  SamplingPointDataWhispAnalysisJob: 'Whisp分析',
  SamplingPointDataWhispCategoryImportJob: 'Whispカテゴリのインポート',
  TaxonomiesExportJob: '分類体系のエクスポート',
  RecordsExportJob: '記録のエクスポート',
  RecordFilesExportJob: '記録ファイルのエクスポート',
  SurveyFilesExportJob: '調査ファイルのエクスポート',
  ChainExportJob: '処理チェーンのエクスポート',
  UsersExportJob: 'ユーザーのエクスポート',
  ActivityLogExportJob: 'アクティビティログのエクスポート',
  InfoExportJob: '出力ファイル情報の生成',
  // validation Report
  VaidationReportGenerationJob: '検証レポートの生成',
  // record Validation
  RecordsValidationJob: `記録の検証`,
  // analysis
  PersistResultsJob: '分析結果の保存',
  PersistOlapDataJob: 'OLAPデータの保存',
}
